export default __webpack_public_path__ + "static/media/contact-here.c0b364bd.png";